/**
 * External dependencies
 */
import { View } from 'react-native';

/**
 * GeChiUI dependencies
 */
import { usePreferredColorSchemeStyle } from '@gechiui/compose';

/**
 * Internal dependencies
 */
import styles from './style.scss';

const BackgroundView = ( { children } ) => {
	const backgroundStyles = usePreferredColorSchemeStyle(
		styles[ 'components-autocomplete__background' ],
		styles[ 'components-autocomplete__background-dark' ]
	);

	return <View style={ backgroundStyles }>{ children }</View>;
};

export default BackgroundView;
